import axios, { getErrorMessage } from './axios';

export const authAPI = {
  // Регистрация заказчика
  registerCustomer: async (userData) => {
    try {
      const response = await axios.post('/auth/register/customer', {
        phone: userData.phone,
        full_name: userData.fullName,
        password: userData.password,
        telegram_id: userData.telegramId || null
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ Ошибка при регистрации:', error.response?.data || error.message);
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка при регистрации')
      };
    }
  },

  // Регистрация исполнителя
  registerExecutor: async (userData) => {
    try {
      const response = await axios.post('/auth/register/executor', {
        phone: userData.phone,
        full_name: userData.fullName,
        password: userData.password,
        city: userData.city || null,
        equipmentList: userData.equipmentList,
        telegram_id: userData.telegramId || null
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка при регистрации')
      };
    }
  },

  // Вход по телефону и паролю
  login: async (phone, password) => {
    try {
      const response = await axios.post('/auth/login', {
        phone,
        password
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error, 'Неверный телефон или пароль')
      };
    }
  },

  // Авторизация через Telegram — отправляем подписанный initData (HMAC проверяется на бэке)
  loginWithTelegram: async (initData) => {
    try {
      const response = await axios.post('/auth/telegram', { init_data: initData });
      return { success: true, data: response.data };
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('❌ Детали ошибки:', error.response?.data);
      }
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка при авторизации через Telegram')
      };
    }
  },

  // Обновление техники исполнителя
  updateExecutorEquipment: async (executorId, equipmentList) => {
    try {
      const response = await axios.put(`/auth/executor/${executorId}/equipment`, {
        equipment: equipmentList
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Update equipment error:', error);
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка при обновлении техники')
      };
    }
  },

  // Переключение онлайн-статуса исполнителя
  setExecutorOnline: async (executorId, isOnline) => {
    try {
      const response = await axios.put(`/auth/executor/${executorId}/online`, {
        is_online: isOnline
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Set online status error:', error);
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка при обновлении статуса')
      };
    }
  },

  // Вход администратора
  adminLogin: async (phone, password) => {
    try {
      const response = await axios.post('/auth/admin/login', {
        phone,
        password
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error, 'Неверный телефон или пароль')
      };
    }
  },

  // Получение статистики (admin)
  getAdminStats: async () => {
    try {
      const response = await axios.get('/admin/stats');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error, 'Ошибка загрузки статистики')
      };
    }
  },
};
